import PropTypes from 'prop-types';

const coordinatesPropTypes = PropTypes.shape({
  x: PropTypes.number,
  y: PropTypes.number,
});

export default coordinatesPropTypes;
